import React from 'react';
import { CheckOutlined } from '@ant-design/icons';
import { useLocation } from 'react-router';
import { useAuth0 } from '@auth0/auth0-react';
import { useSnapshot } from 'valtio';
import { VIPStore } from '@/utils/store/vip';
import axios from 'axios';
import dayjs from 'dayjs';
import { ERROR_MESSAGES } from '@/constants/messages';
import { createPayment, addOrderTest } from '@/services/api';
import { handleError } from '@/utils/helpers';
import { supabaseAuthStore } from '@/utils/store/supabaseAuth';

interface Props {}

const PriceCard = ({title, desc}) => {

    const location = useLocation();
    const query = new URLSearchParams(location.search);
    const isDebug = query.get("isDebug");

    const supabaseAuth = useSnapshot(supabaseAuthStore);
    
    const user = supabaseAuth.user ;
    const isAuthenticated = supabaseAuth.isAuthenticated ;
    const isLoading = supabaseAuth.isLoading ;
    
    const { data, runFetch } = useSnapshot(VIPStore);
    console.log(20, data);

  return (
    <div className="bg-white rounded-2xl border border-gray-100 shadow-lg overflow-hidden">
      <div className="p-6">
        <span className="inline-block px-3 py-1 bg-gray-900 text-white text-xs font-medium rounded-full mb-4">
          新用户专享价
        </span>
        
        <div className="text-center py-4">
          <div className="flex items-baseline justify-center gap-1">
            <span className="text-4xl font-bold text-gray-900">¥?</span>
            <span className="text-gray-500 text-sm">/月</span>
          </div>
          <div className="text-gray-400 text-sm line-through mt-1">原价 ¥??</div>
        </div>
        
        <div className="space-y-3 py-4 border-t border-gray-100">
          <div className="flex items-center gap-2.5">
            <div className="w-5 h-5 rounded-full bg-emerald-50 flex items-center justify-center">
              <CheckOutlined className="text-emerald-500 text-xs"/>
            </div>
            <span className="text-gray-600 text-sm">每月?小时转写</span>
          </div>
          <div className="flex items-center gap-2.5">
            <div className="w-5 h-5 rounded-full bg-emerald-50 flex items-center justify-center">
              <CheckOutlined className="text-emerald-500 text-xs"/>
            </div>
            <span className="text-gray-600 text-sm">AI整理</span>
          </div>
          <div className="flex items-center gap-2.5">
            <div className="w-5 h-5 rounded-full bg-emerald-50 flex items-center justify-center">
              <CheckOutlined className="text-emerald-500 text-xs"/>
            </div>
            <span className="text-gray-600 text-sm">导出</span>
          </div>
        </div>
        
        <label className="flex items-start gap-2.5 py-4 cursor-pointer">
          <input type="checkbox" defaultChecked className="w-4 h-4 rounded border-gray-300 text-gray-900 focus:ring-gray-500 mt-0.5" />
          <div>
            <div className="text-sm text-gray-700">同意自动续费协议</div>
            <div className="text-xs text-gray-400 mt-0.5">次月起按¥??/月续费</div>
          </div>
        </label>
        
        <button 
          className="w-full py-2.5 bg-gray-900 hover:bg-gray-800 text-white text-sm font-medium rounded-xl transition-colors"
          onClick={async ()=>{
            if(isDebug){
              if(isAuthenticated && !isLoading){
                try {
                  const response = await addOrderTest({
                    userId: supabaseAuth.id,
                    createTime: dayjs().unix(),
                    payAmount: 0.0
                  });
                  console.log(62, response.data);
                  if (response.data.success) {
                    runFetch(supabaseAuth.id)
                  } else {
                    handleError(new Error(response.data.data.message), ERROR_MESSAGES.PAYMENT_CREATION_FAILED);
                  }
                } catch (error) {
                  handleError(error, ERROR_MESSAGES.PAYMENT_CREATION_FAILED);
                }
              }
            } else {
              console.log("is not d")
            }
          }}
        >
          立即续费
        </button>
      </div>
    </div>
  )
}

export default PriceCard
